import paymentHelpers from '@/library/payments/paymentHelpers'

function getReturnUrl (param) {
  const origin = window.ctsautoconf.WEB_SERVER_HOSTNAME || ''
  const capacitorIsEnabled = window.ctsautoconf.CAPACITOR_ENABLED || false
  const isMobileApp = window.ctsautoconf.MOBILE_LS || false
  if (capacitorIsEnabled && isMobileApp) {
    const formatedOrigin = paymentHelpers.removeTrailingSlash(origin)
    return `${formatedOrigin}/account/sightline/sightline-redirect-mobile?IDMMSITXRequest=${param}`
  }
  return `${window.location.href}?IDMMSITXRequest=${param}`
}

function getStaticPageBaseUrl (param) {
  const origin = window.ctsautoconf.WEB_SERVER_HOSTNAME || ''
  const capacitorIsEnabled = window.ctsautoconf.CAPACITOR_ENABLED || false
  const isMobileApp = window.ctsautoconf.MOBILE_LS || false
  if (capacitorIsEnabled && isMobileApp) {
    const formatedOrigin = paymentHelpers.removeTrailingSlash(origin)
    return formatedOrigin
  }
  return window.location.origin
}

function checkIsRedirectedFromInAppBrowserAndIntercept () {
  console.log(`checkIsRedirectedFromInAppBrowserAndIntercept`)
  let url = window.location.href
  console.log(url)
  const IsRedirectedFromSightline = url.includes('sightline-redirect-mobile')
  const isWebView = !window.ctsautoconf.MOBILE_LS
  console.log(`IsRedirectedFromSightline: ${IsRedirectedFromSightline}`)
  console.log(`isWebView: ${isWebView}`)
  console.log(`IsRedirectedFromSightline && isWebView: ${IsRedirectedFromSightline && isWebView}`)
  if (IsRedirectedFromSightline && isWebView) {
    console.log(`Usao u IF uslov`)
    console.log(`URL before replacement: ${url}`)
    url = url.replace(/\/sightline-redirect-mobile-[A-Za-z]+/, '')
    console.log(`URL after replacement: ${url}`)
    const origin = window.location.origin
    const formatedOrigin = paymentHelpers.removeTrailingSlash(origin)
    url = url.replaceAll(formatedOrigin, 'igt-nuvei-link:/')
    document.location = url
  }
}

function isSightlineTransaction (url) {
  const IsRedirectedFromSightline = url.includes('sightline-redirect-mobile')
  return IsRedirectedFromSightline
}

export default {
  getReturnUrl,
  checkIsRedirectedFromInAppBrowserAndIntercept,
  getStaticPageBaseUrl,
  isSightlineTransaction
}



// WEBPACK FOOTER //
// ./src/library/payments/sightlineManager.js